<template>
  <div class="card shadow-sm border border-light" style="padding:16px; max-height: 312px;">
    <titles class="fw-semibold mb-2" text="Yeni subroqasiya işlərinin aylıq dinamikası"
      style="color: #23426e; margin: 0 !important;" />
    <hr class="my-2" />
    <default-line-chart style="padding-bottom:20px; max-height: 270px; " v-if="labels.length && counts.length" :id="'monthly-cases-chart'" :chart="{
      labels: labels,
      datasets: [
        {
          label: 'Yeni işlər',
          data: counts
        }
      ]
    }" />

    <div class="text-end text-muted mt-2" style="font-size: 13px">
      <i class="fa-solid fa-calendar-days"></i> Son 6 ay
    </div>
  </div>
</template>

<script>
import { GetMonthlyCases } from "@/project/Source/stats.js";
import Titles from "@/project/Components/Titles.vue";
import DefaultLineChart from "@/examples/Charts/DefaultLineChart.vue";

export default {
  name: "MonthlyCasesChart",
  components: {
    Titles,
    DefaultLineChart,
  },
  data() {
    return {
      labels: [],
      counts: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    getMonthName(num) {
      return [
        "Yan", "Fev", "Mar", "Apr", "May", "İyun",
        "İyul", "Avq", "Sen", "Okt", "Noy", "Dek"
      ][num - 1];
    },
    async loadData() {
      try {
        const res = await GetMonthlyCases();
        this.labels = res.data.data.map(item => this.getMonthName(item.month));
        this.counts = res.data.data.map(item => item.count);
      } catch (err) {
        console.error("Error loading chart data:", err);
      }
    },
  },
};
</script>
